import { toggleMaxHeight } from './helper'

document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('.accordion');
    accordions.forEach((elem) => {
        const accordionTrigger = elem.querySelector('.accordion__head');
        const accordionBody = elem.querySelector('.accordion__inner');

        accordionTrigger.addEventListener('click', () => {
            toggleMaxHeight(accordionBody as HTMLElement);
            accordionTrigger.classList.toggle('active');
        })
    })
})